import classnames from 'classnames';
import moment from 'moment';
import React from 'react';
import DownloadCSV from '../../../../components/DownloadCSV';
import {
  DualTDWithClickableToolTip,
  HoverableDualTD,
  HoverableTD
} from '../../../../components/HoverableTD';
import NoDataToDisplay from '../../../../components/NoDataToDisplay';
import PopoutWindow from '../../../../components/PopoutWindow';
import RangedDtPicker from '../../../../components/RangedDtPicker';
import Wait4Me from '../../../../components/Wait4Me';
import { getCustomerTransactionHistory } from '../../../../services/tm/investigationDetail';
import Table from '../../dashboard/TookiTakiTable/Table/index';
import style from './index.scss';
import {
  getAlertIDFromURL,
  getCodesFromLC,
  putHyphenIfEmpty,
  responseFormatter
} from '../../../../services/util';
import { parseColumnsForTransactionDetails } from '../investigationDetailSettingsUtil';
import * as PropTypes from 'prop-types';

import { convertDateInputToEpoch } from '../../../../util/timezone';

import { find, has, isEmpty } from '../../../../util/lodashlike';
const transactionMappingBackup = [
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'ATM-withdrawal',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'CDM-cash-deposit',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'card-charge',
    description: 'CARD'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'card-payment',
    description: 'CARD'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'cash-equivalent-deposit',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'cash-equivalent-withdrawal',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-cheque',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-local-fund-transfer',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-overseas-fund-transfer',
    description: 'REMITTANCE'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-cheque',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-local-fund-transfer',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-overseas-fund-transfer',
    description: 'REMITTANCE'
  }
];

/**
 * TransactionRow single row component
 * @param txt (any type of text)
 * @returns {div}
 * @constructor
 */
const TransactionRow = ({ txt }) => {
  return (
    <div className="row" style={{ textAlign: 'center', padding: 10 }}>
      <div className="col-md-12">
        <p style={{ textAlign: 'center' }}>{txt}</p>
      </div>
    </div>
  );
};

/**
 * TRANSACTION_HEADER
 */
export const TRANSACTION_HEADER = [
  {
    name: 'Transaction ID',
    label: 'Transaction ID',
    key: 'id'
  },
  {
    name: 'Account Number',
    label: 'Account Number',
    key: 'source'
  },
  {
    name: 'Account Currency',
    label: 'Account Currency',
    key: 'accountCurrency'
  },
  {
    name: 'Transaction Currency',
    label: 'Transaction Currency',
    key: 'transactionCurrency'
  },
  {
    name: 'Transaction ID',
    label: 'Transaction ID',
    key: 'localCurrencyEquivalent',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'Transaction Description',
    label: 'Transaction Description',
    key: 'transactionTypeCode'
  },
  {
    name: 'Originator',
    label: 'Originator',
    key: 'originator'
  },
  {
    name: 'Beneficiary',
    label: 'Beneficiary',
    key: 'beneficiary'
  },
  {
    name: 'Cheque no.',
    label: 'Cheque no.',
    key: 'chequeNo'
  },
  {
    name: 'Your reference',
    label: 'Your reference',
    key: 'yourReference'
  },
  {
    name: 'Bank information',
    label: 'Bank information',
    key: 'bankInfo'
  },
  {
    name: 'Account number',
    label: 'Account number',
    key: 'creditCardNumber'
  },
  {
    name: 'Tranche no.',
    label: 'Tranche no.',
    key: 'trancheNo'
  }
];
/**
 * TRANSACTION_DOWNLOAD_HEADER
 */
export const TRANSACTION_DOWNLOAD_HEADER = [
  {
    name: 'Transaction ID',
    label: 'Transaction ID',
    key: 'id'
  },
  {
    name: 'Transaction Date',
    label: 'Transaction Date',
    key: 'date'
  },
  {
    name: 'Account number',
    label: 'Account number',
    key: 'source'
  },
  {
    name: 'Country of Transaction',
    label: 'Country of Transaction',
    key: 'countryOfTransaction'
  },
  {
    name: 'Account Currency',
    label: 'Account Currency',
    key: 'accountCurrency'
  },
  {
    name: 'Transaction Amount(Account Currency)',
    label: 'Transaction Amount(Account Currency)',
    key: 'amount',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'Transaction Currency',
    label: 'Transaction Currency',
    key: 'transactionCurrency'
  },
  {
    name: 'Transaction Amount',
    label: 'Transaction Amount',
    key: 'transactionCurrencyAmount',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'Transaction Amount (SGD)',
    label: 'Transaction Amount (SGD)',
    key: 'localCurrencyEquivalent',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    name: 'CR/DR',
    label: 'CR/DR',
    key: 'credit_debit'
  },
  {
    name: 'Transaction Description',
    label: 'Transaction Description',
    key: 'transactionTypeCode'
  },
  {
    name: 'Transaction Type',
    label: 'Transaction Type',
    key: 'type'
  },
  {
    name: 'Originator Name',
    label: 'Originator Name',
    key: 'originator'
  },
  {
    name: 'Originator Bank Country',
    label: 'Originator Bank Country',
    key: 'originatorBankCountryCode'
  },
  {
    name: 'Beneficiary Name',
    label: 'Beneficiary Name',
    key: 'beneficiary'
  },
  {
    name: 'Beneficiary Bank Country',
    label: 'Beneficiary Bank Country',
    key: 'beneficiaryBankCountryCode'
  },
  {
    name: 'Cheque Number',
    label: 'Cheque Number',
    key: 'chequeNo'
  },
  {
    name: 'TD Number',
    label: 'TD Number',
    key: 'tdNumber'
  },
  {
    name: 'Your Reference',
    label: 'Your Reference',
    key: 'yourReference'
  },
  {
    name: 'Our Reference',
    label: 'Our Reference',
    key: 'ourReference'
  },
  {
    name: 'Bank information',
    label: 'Bank information',
    key: 'bankInfo'
  },
  {
    name: 'Credit Card Number',
    label: 'Credit Card Number',
    key: 'creditCardNumber'
  },
  {
    name: 'MCC - Merchant Name',
    label: 'MCC - Merchant Name',
    key: 'mccMerchantName'
  },
  {
    name: 'Tranche No.',
    label: 'Tranche No.',
    key: 'trancheNo'
  },
  {
    name: 'Counter Party',
    label: 'Counter Party',
    key: 'counterParty'
  },
  {
    name: 'Originator Address',
    label: 'Originator Address',
    key: 'originatorAddress'
  },
  {
    name: 'Beneficary Address',
    label: 'Beneficary Address',
    key: 'beneficiaryAddress'
  },
  {
    name: 'Remittance Country',
    label: 'Remittance Country',
    key: 'remittanceCountry'
  },
  {
    name: 'Remittance Payment Details',
    label: 'Remittance Payment Details',
    key: 'remittancePaymentDetails'
  },
  // {
  //   name: 'Additional Information`',
  //   label: 'Additional Information',
  //   key: 'bankInfo',
  // },
  {
    name: 'MSG Type',
    label: 'MSG Type',
    key: 'swiftMsgType'
  },
  {
    name: 'MSG Information',
    label: 'MSG Information',
    key: 'swiftMsgInfo'
  },
  {
    name: 'ATM ID',
    label: 'ATM ID',
    key: 'atmId'
  },
  {
    name: 'ATM Location',
    label: 'ATM Location',
    key: 'atmLocation'
  },
  {
    name: 'Teller ID',
    label: 'Teller ID',
    key: 'tellerId'
  }
];

export const DISPLAY_REMITTANCE_HEADER = [
  {
    label: 'Counter Party',
    key: 'counterParty'
  },
  {
    label: 'Originator Address',
    key: 'originatorAddress'
  },
  {
    label: 'Beneficary Address',
    key: 'beneficiaryAddress'
  },
  {
    label: 'Remittance Country',
    key: 'remittanceCountry'
  },
  {
    label: 'Remittance Payment Details',
    key: 'remittancePaymentDetails'
  },
  // {
  //   label: 'Additional Information',
  //   key: 'bankInfo',
  // },
  {
    label: 'MSG Type',
    key: 'swiftMsgType'
  },
  {
    label: 'MSG Information',
    key: 'swiftMsgInfo'
  }
];
/**
 * TransactionHistoryHeader
 * @returns {thead}
 * @constructor
 */
const TransactionHistoryHeader = ({ settings, widthArray }) => {
  const widthStyle = (index) => {
    return widthArray
      ? {
          width: widthArray[index] + 'px',
          minWidth: widthArray[index] + 'px',
          maxWidth: widthArray[index] + 'px'
        }
      : {};
  };

  if (settings) {
    const tableHeaders = settings.map((columnItem, columnItemIndex) => {
      if (columnItem) {
        return (
          <th style={widthStyle(columnItemIndex)} key={columnItemIndex}>
            {columnItem.label}
            {columnItem.subColumns &&
              columnItem.subColumns.map((subColumn) => {
                if (subColumn) {
                  return (
                    <span>
                      <br />
                      <br />
                      {subColumn.label}
                    </span>
                  );
                }

                return null;
              })}
          </th>
        );
      }

      return null;
    });

    return (
      <thead>
        <tr>{tableHeaders}</tr>
      </thead>
    );
  }

  return (
    <thead>
      <tr>
        <th style={widthStyle(0)}>Transaction ID</th>
        <th style={widthStyle(1)}>Account Number</th>
        <th style={widthStyle(2)}>Account Currency</th>
        <th style={widthStyle(3)}>Transaction Currency</th>
        <th style={widthStyle(4)}>Amount(SGD)</th>
        <th style={widthStyle(5)}>Transaction Description</th>
        <th style={widthStyle(6)}>Originator</th>
        <th style={widthStyle(7)}>Beneficiary</th>
        <th style={widthStyle(8)}>Cheque Number</th>
        <th style={widthStyle(9)}>Your Reference</th>
        <th className={style.colspan2Top} style={widthStyle(10)}>
          Bank Information
        </th>
        <th style={widthStyle(11)}>Credit Card Number</th>
        <th className={style.colspan2Top} style={widthStyle(12)}>
          Tranche No.
        </th>
      </tr>
      <tr>
        <th style={widthStyle(0)}>Transaction Date</th>
        <th style={widthStyle(1)}>Country Of Transaction</th>
        <th style={widthStyle(2)}>Amount</th>
        <th style={widthStyle(3)}>Amount</th>
        <th style={widthStyle(4)}>CR/DR</th>
        <th style={widthStyle(5)}>Transaction Type</th>
        <th style={widthStyle(6)}>Originator Bank Country</th>
        <th style={widthStyle(7)}>Beneficiary Bank Country</th>
        <th style={widthStyle(8)}>TD Number</th>
        <th style={widthStyle(9)}>Our Reference</th>
        <th className={style.colspan2Bottom} style={widthStyle(10)}></th>
        <th style={widthStyle(11)}>MCC - Merchant Name</th>
        <th className={style.colspan2Bottom} style={widthStyle(12)}></th>
      </tr>
    </thead>
  );
};
/**
 * multiRowMap for returning dual headers
 */
const multiRowMap = {
  id: ['date'],
  source: ['countryOfTransaction'],
  accountCurrency: ['amount'],
  transactionCurrency: ['transactionCurrencyAmount'],
  localCurrencyEquivalent: ['credit_debit'],
  transactionTypeCode: ['type'],
  originator: ['originatorBankCountryCode'],
  beneficiary: ['beneficiaryBankCountryCode'],
  chequeNo: ['tdNumber'],
  yourReference: ['ourReference'],
  creditCardNumber: ['mccMerchantName']
};

const formattedMoneyMap = {
  amount: 'amount',
  transactionCurrencyAmount: 'transactionCurrencyAmount',
  localCurrencyEquivalent: 'localCurrencyEquivalent'
};

/**
 * TransactionTableComponent
 */
export class TransactionTableComponent extends React.Component {
  constructor(props) {
    super(props);
    this.refArray = [];
    this.state = {
      transactionProductMapping: []
    };
  }

  async componentDidMount() {
    let mapping = await getCodesFromLC('transactionProductMapping');
    if (isEmpty(mapping)) {
      mapping = transactionMappingBackup;
    }
    this.setState({ transactionProductMapping: mapping });
  }

  /**
   * onToggleToolTip func
   * @param ref
   */
  onToggleToolTip = (ref) => {
    /*
     *  False []
     *   push to array
     *   called toggle func to TRUE
     *  False
     *   take from array
     *   toggle func() from array
     *   push new one to empty Array
     *   toggle func()
     *  True
     *   take from array
     *   toggle func()
     *   empty array
     * */
    try {
      if (this.refArray.length > 0) {
        const { toggleFunction, toggleState } = ref;
        if (toggleState) {
          toggleFunction();
          this.refArray = [];
        } else {
          const { toggleFunction: innerTF } = this.refArray[0];
          innerTF();
          this.refArray = [];
          this.refArray.push(ref);
          toggleFunction();
        }
      } else {
        const { toggleFunction } = ref;
        toggleFunction();
        this.refArray.push(ref);
      }
    } catch (e) {
      ref[0].toggleFunction();
    }
  };

  render() {
    let { data, settings, keys, columnWidth, transactionTypes, isModal } =
      this.props;
    let usableKeys = settings ? settings : keys;

    let multiMapWithSettings = multiRowMap;
    if (settings) {
      multiMapWithSettings = {};

      settings.map((currentColumn) => {
        if (currentColumn.subColumns) {
          multiMapWithSettings[currentColumn.key] = currentColumn.subColumns
            .map((subColumnItem) => {
              if (subColumnItem) {
                return subColumnItem.key;
              }

              return null;
            })
            .filter((keyword) => keyword !== null);
        } else {
          multiMapWithSettings[currentColumn.key] = [];
        }
      });
    }

    const formattedData = data
      .map((currentTransactionItem) => {
        if (currentTransactionItem) {
          if (transactionTypes) {
            const selectedTransactionType = transactionTypes.filter(
              (item) => item.code === currentTransactionItem.type
            );

            if (
              Array.isArray(selectedTransactionType) &&
              selectedTransactionType.length > 0
            ) {
              return {
                ...currentTransactionItem,
                transactionTypeLabel: selectedTransactionType[0].description
              };
            } else {
              return currentTransactionItem;
            }
          } else {
            return currentTransactionItem;
          }
        }

        return null;
      })
      .filter((item) => item !== null);

    return (
      <Table isStriped={true} class={style.stickyTransactionHeader}>
        <TransactionHistoryHeader
          settings={settings}
          keys={keys}
          widthArray={columnWidth}
        />
        <tbody>
          {formattedData.map((tableRow, tableRowIndex) => {
            return (
              <tr key={tableRowIndex}>
                {usableKeys.map((row, index) => {
                  const firstDataPoint = putHyphenIfEmpty(tableRow[row.key]);
                  if (multiMapWithSettings[row.key]) {
                    let secondDataPoint =
                      tableRow[multiMapWithSettings[row.key][0]];

                    if (row.key === 'transactionTypeCode') {
                      const mappingValue = find(
                        this.state.transactionProductMapping,
                        { code: secondDataPoint }
                      );
                      if (
                        has(mappingValue, 'description') &&
                        mappingValue.description === 'REMITTANCE'
                      ) {
                        return (
                          <DualTDWithClickableToolTip
                            index={index}
                            widthArray={columnWidth}
                            onToggleToolTip={this.onToggleToolTip}
                            row={tableRow}
                            firstDataPoint={firstDataPoint}
                            mappingValue={mappingValue}
                            secondDataPoint={putHyphenIfEmpty(
                              tableRow['transactionTypeLabel']
                            )}
                          />
                        );
                      }

                      secondDataPoint = tableRow['transactionTypeLabel'];
                      return (
                        <HoverableDualTD
                          isTruncated={!isModal}
                          index={index}
                          widthArray={columnWidth}
                          row={row}
                          isFirstMoney={row.formatNumeric === true}
                          isSecondMoney={
                            formattedMoneyMap[
                              multiMapWithSettings[row.key][0]
                            ] !== undefined
                          }
                          firstDataPoint={putHyphenIfEmpty(firstDataPoint)}
                          secondDataPoint={putHyphenIfEmpty(secondDataPoint)}
                        />
                      );
                    }
                    return (
                      <HoverableDualTD
                        isTruncated={!isModal}
                        index={index}
                        widthArray={columnWidth}
                        row={row}
                        isFirstMoney={row.formatNumeric === true}
                        isSecondMoney={
                          formattedMoneyMap[
                            multiMapWithSettings[row.key][0]
                          ] !== undefined
                        }
                        firstDataPoint={putHyphenIfEmpty(firstDataPoint)}
                        secondDataPoint={putHyphenIfEmpty(secondDataPoint)}
                      />
                    );
                  }
                  return (
                    <HoverableTD
                      isTruncated={!isModal}
                      index={index}
                      widthArray={columnWidth}
                      row={row}
                      firstDataPoint={putHyphenIfEmpty(firstDataPoint)}
                    />
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

TransactionTableComponent.propTypes = {
  data: PropTypes.any,
  keys: PropTypes.any
};

/**
 * AssocTransaction Section component
 */
class AssocTransaction extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);

    this.state = {
      isPopedOut: false,
      ruleValue: {
        id: 0,
        name: '--Rule Unspecified--'
      },
      rulesOption: [
        {
          id: 0,
          name: '--Rule Unspecified--'
        },
        {
          id: 1,
          name: 'Excessive Cash Eq Deposits'
        },
        {
          id: 2,
          name: 'Excessive Daily Cash Eq Deposits'
        },
        {
          id: 3,
          name: 'Excessive Daily Cash Deposit Volume Rule'
        },
        {
          id: 4,
          name: 'Excessive Monthly Cash Deposit Volume Rule'
        },
        {
          id: 5,
          name: 'Excessive Outgoing High Risk Fund Transfers'
        },
        {
          id: 6,
          name: 'Excessive Outgoing Fund Transfers-High Volume'
        }
      ],
      filterActive: false,
      filterApplied: false,
      tableWidth: '100%',
      columnWidth: [],
      dateRange: {
        startDate: moment().subtract(30, 'days').add(1, 'days'),
        endDate: moment(),
        activeRangeNo: 2
      },
      currentPage: 0,
      // individual filter for each columns
      columnFilters: {
        amount: 0,
        credit: null,
        destination: null,
        tyle: null
      },
      triggered: false,
      transactionData: [],
      //actual filter information passed in by the filter component
      combinedFilters: {
        startAmount: null,
        endAmount: null,
        cd: null,
        destinations: null,
        types: null
      },
      csvDownloadClicked: false
    };

    this.dataUrlMap = {};
  }

  UNSAFE_componentWillMount() {
    if (this.props.onDateRangeChanged) {
      this.props.onDateRangeChanged(
        this.state.dateRange.startDate,
        this.state.dateRange.endDate
      );
    }
  }

  componentDidMount() {
    this.updateTableWidth();
    window.addEventListener('resize', this.updateTableWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateTableWidth);
  }

  onDateChange = (start, end, rangeNo) => {
    const newDateRange = {
      startDate: start,
      endDate: end,
      activeRangeNo: rangeNo
    };
    this.setState({
      ...this.state,
      dateRange: newDateRange,
      currentPage: 0,
      filterApplied: false,
      filterActive: false,
      combinedFilters: {
        startAmount: null,
        endAmount: null,
        cd: null,
        destinations: null,
        types: null
      }
    });

    this.props.onDateRangeChanged(start, end);
  };

  onScrollToLoad = () => {
    const {
      currentPage,
      dateRange: { startDate, endDate }
    } = this.state;
    this.setState({
      ...this.state,
      currentPage: currentPage + 1
    });

    this.props.onScrollToLoad(startDate, endDate, (currentPage + 1) * 20);
  };

  onTransactionHistoryDownload = async (customerID) => {
    this.setState({ transactionData: [] });
    const { alertID } = getAlertIDFromURL();
    const {
      dateRange: { startDate, endDate }
    } = this.state;
    const tranData = await getCustomerTransactionHistory({
      customerId: customerID,
      alertId: alertID,
      from: convertDateInputToEpoch(startDate, true),
      to: convertDateInputToEpoch(endDate, true),
      offset: 0,
      limit: 5000
    });
    const { associated_transactions } = tranData;
    if (associated_transactions.length === 0) {
      this.setState({ transactionData: [{}] });
      return false;
    }
    const formattedResponse = responseFormatter(
      associated_transactions,
      TRANSACTION_DOWNLOAD_HEADER
    );
    this.setState({ transactionData: formattedResponse });
  };

  getFileName = () => {
    return `${this.state.dateRange.startDate.format(
      'DDMMYYYY'
    )}-to-${this.state.dateRange.endDate.format('DDMMYYYY')}.csv`;
  };

  applyFilter = (filterValue) => {
    let { destinations, types, cd } = filterValue;
    const { dateRange } = this.state;

    this.setState({
      filterApplied: true,
      filterActive: false,
      combinedFilters: {
        ...this.state.combinedFilters,
        destinations,
        types,
        cd
      }
    });

    const filterPayload = {
      ...filterValue,
      dateRange
    };

    if (this.props.applyFilter) {
      this.props.applyFilter(filterPayload);
    }
  };

  cancelFilter = () => {
    this.setState({
      filterApplied: false,
      filterActive: false
    });
  };

  toggleFilter = () => {
    this.setState({
      filterActive: !this.state.filterActive
    });
  };

  togglePopout = () => {
    ['filter', 'filterChecked'].forEach((title) => {
      let querySelector = `img[title='${title}']`;
      let image = document.querySelector(querySelector);
      if (image) {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext('2d').drawImage(image, 0, 0);
        const dataUrl = canvas.toDataURL('image/png');
        this.dataUrlMap[title] = dataUrl;
      }
    });

    this.setState({
      isPopedOut: !this.state.isPopedOut
    });
  };

  updateTableWidth = () => {
    const elem = document.getElementById('associatedTransactionContent');
    if (elem) {
      const computedStyle = window.getComputedStyle(elem, null);
      const newWidth = computedStyle.getPropertyValue('width');
      let widthArray = [10, 10, 6, 6, 6, 10, 7, 7, 5, 6, 6, 12, 9].map((x) =>
        ((parseInt(newWidth) * x) / 100).toFixed()
      );
      this.setState({
        tableWidth: parseInt(newWidth),
        columnWidth: widthArray
      });
    }
  };

  render() {
    const { isPopedOut, dateRange, transactionData, columnWidth } = this.state;
    const { assocTransaction, isLoading, settings, transactionTypes } =
      this.props;
    const assocTransactionData = assocTransaction ? assocTransaction.data : '';
    const customerID = assocTransactionData
      ? assocTransactionData.customerId
      : '';
    let rows = assocTransactionData
      ? assocTransactionData.associated_transactions
      : [];

    let transactionDetailsSettings = null;

    if (settings) {
      transactionDetailsSettings = parseColumnsForTransactionDetails(settings);
    }

    //table content
    let paginatedRowOption = [];
    if (rows && rows.length > 0) {
      rows.forEach((row, i) => {
        paginatedRowOption.push(<tr>{[]}</tr>);
      });

      if (assocTransactionData.hasMore) {
        if (!isLoading) {
          paginatedRowOption.push(
            <div className="row" style={{ textAlign: 'center', padding: 10 }}>
              <div className="col-md-12">
                <a onClick={this.onScrollToLoad} className={style.loadMore}>
                  Load More
                </a>
              </div>
            </div>
          );
        } else {
          paginatedRowOption.push(<TransactionRow txt={'Loading...'} />);
        }
      }
    } else if (assocTransaction?.isFetching || isLoading === undefined) {
      paginatedRowOption.push(
        <div
          className="row"
          style={{ textAlign: 'center', padding: 10, overflow: 'hidden' }}>
          <div style={{ overflow: 'hidden' }} className="col-md-12">
            <Wait4Me />
          </div>
        </div>
      );
    } else {
      paginatedRowOption.push(<NoDataToDisplay />);
    }

    //Transactions Section Header
    let sectionHeader = (
      <div className={classnames(style.primaryTableHead, 'row m-0')}>
        <span className={style.assocTitle}>Transaction Details</span>
        <div className={style.dateSection}>
          <RangedDtPicker
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
            activeRangeNo={dateRange.activeRangeNo}
            onDateChange={this.onDateChange}
          />
        </div>

        {/*Download Option Start */}
        <DownloadCSV
          csvData={transactionData}
          csvHeaders={TRANSACTION_DOWNLOAD_HEADER}
          fileName={this.getFileName()}
          onDownloadClick={() => {
            this.onTransactionHistoryDownload(customerID);
          }}
        />
        {/*Download Option End */}
      </div>
    );
    let renderedView = (
      <div
        className={classnames(style.card, 'mt-3')}
        id="associatedTransactionContent">
        <div className={classnames(style.sectionHeader)}>{sectionHeader}</div>
        <div></div>
        <div className={classnames(style.card_body)}>
          <TransactionTableComponent
            settings={transactionDetailsSettings}
            transactionTypes={transactionTypes}
            keys={TRANSACTION_HEADER}
            data={rows}
            columnWidth={columnWidth}
          />
          {paginatedRowOption}
        </div>
      </div>
    );

    if (!isPopedOut) {
      return <div>{renderedView}</div>;
    }

    return (
      <div>
        <div style={{ display: 'none' }}>{renderedView}</div>
        <PopoutWindow
          width={window.innerWidth}
          height={500}
          imageUrlMap={this.dataUrlMap}>
          {renderedView}
        </PopoutWindow>
      </div>
    );
  }
}

AssocTransaction.propTypes = {};

export default AssocTransaction;
